import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DataSource, CollectionViewer } from '@angular/cdk/collections';

import { environmentsActions } from '@src/store/reducers/environmentsReducer';
import { MultiUpgradePreValidatePackageDialogData } from './multi-upgrade-prevalidate-package-dialog.data';

import _ from 'lodash';

type Package = any;
const PAGE_SIZE = 10;

export class MultiUpgradePackageDataSource extends DataSource<Package | undefined> {
    public defaultSort: any[];

    private fetchedPages = new Set<number>();

    private cachedData = Array.from<Package>({ length: 1 });
    private dataStream = new BehaviorSubject<(Package | undefined)[]>(this.cachedData);

    private subscription = new Subscription();
    private loaded = false;

    constructor(
        private data: MultiUpgradePreValidatePackageDialogData,
        private filterText: string,
        private filterOption: string,
        private displayAdHocs: any) {
        super();
    }

    public get length() {
        return this.cachedData.length;
    }

    public connect(collectionViewer: CollectionViewer): Observable<(Package | undefined)[]> {
        this.subscription.add(collectionViewer.viewChange.subscribe(async (range) => {
            const startPage = this.getPageForIndex(range.start);
            const endPage = this.getPageForIndex(range.end);
            for (let i = startPage; i <= endPage; i++) {
                await this.fetchPage(i);
            }
        }));

        return this.dataStream;
    }

    public disconnect() {
        this.subscription.unsubscribe();
    }

    public async reset(filterText: string, filterOption: string, displayAdHocs: any) {
        this.filterText = filterText;
        this.filterOption = filterOption;
        this.displayAdHocs = displayAdHocs;
        this.cachedData = Array.from<Package>({ length: 1 });
        this.fetchedPages = new Set<number>();
        await this.fetchPage(0);
    }

    public indexOf(element: any) {
        return this.cachedData.indexOf(element);
    }

    public splice(start: number, deleteCount?: number) {
        this.cachedData.splice(start, deleteCount);
        this.dataStream.next(this.cachedData);
    }

    public push(element: any) {
        this.cachedData.push(element);
        this.dataStream.next(this.cachedData);
    }

    public reverse() {
        const result = this.cachedData.reverse();
        return result;
    }

    public sort(compareFn: (a: any, b: any) => number) {
        this.cachedData.sort(compareFn);
        this.dataStream.next(this.cachedData);
    }

    public forEach(callbackFn: (element: any) => void) {
        this.cachedData.forEach(callbackFn);
        this.dataStream.next(this.cachedData);
    }

    public async loadMore() {
        if (!this.loaded && this.cachedData.length < PAGE_SIZE) {
            await this.fetchPage(this.fetchedPages.size);
        }
    }

    private getPageForIndex(index: number): number {
        return Math.floor(index / PAGE_SIZE);
    }

    private async fetchPage(page: number) {
        if (this.fetchedPages.has(page)) {
            return;
        }
        this.fetchedPages.add(page);

        const date = new Date().toISOString();
        await this.getPackages(page, {
            filterText: this.filterText,
            filterOption: this.filterOption,
            projectId: this.data.project.projectId,
            envId: this.data.environment.id,
            pageNumber: page,
            pageSize: PAGE_SIZE,
            startDate: date,
            endDate: date,
            displayAdHocs: this.displayAdHocs
        });
    }

    private async getPackages(page: number, payload: any) {
        const response = await this.data.dispatch({
            payload,
            type: environmentsActions.GET_PACKAGES_FOR_DEPLOY_BY_TASK
        });
        if (response && response.data) {
            const packages = response.data.filter(x => !this.data.packages.selectedPackages.some(y => y.id === x.id));
                this.cachedData.splice(page * PAGE_SIZE, packages.length, ...packages);
                this.dataStream.next(this.cachedData);
                if(this.cachedData.includes(undefined)){
                    this.cachedData = [];
                }
                this.defaultSort = [
                    ...(this.defaultSort || []),
                    ...this.cachedData.map((x: any) => ({ id: x.id, order: x.order }))
                ];
                this.defaultSort = _.uniqBy([...this.defaultSort], 'id');
        } else {
            this.loaded = true;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/multi-upgrade-prevalidate-package-dialog/multi-upgrade-package.data-source.ts